import ReactPaginate from 'react-paginate'
import { useState } from 'react'
import Grid from '../Grid'
import ArrowLeft from '/public/icons/icon-pagination-left.svg'
import ArrowRight from '/public/icons/icon-pagination-right.svg'
import Scroll from 'react-scroll'
import styles from './styles.module.scss'

const Paginate = ({ items, grid, itemsPerPage, sectionRef }) => {
  const scroll = Scroll.animateScroll
  const [itemOffset, setItemOffset] = useState(0)
  const endOffset = itemOffset + itemsPerPage
  const currentItems = items.slice(itemOffset, endOffset)
  const pageCount = Math.ceil(items.length / itemsPerPage)

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length
    sectionRef &&
      scroll.scrollTo(
        sectionRef.current?.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          150
      )
    setItemOffset(newOffset)
  }
  return (
    <div className={styles.pagination}>
      <Grid variant={grid}>
        {currentItems && currentItems.map((item) => item)}
      </Grid>

      {!(items.length <= itemsPerPage) && (
        <ReactPaginate
          breakLabel="..."
          nextLabel={<ArrowRight />}
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel={<ArrowLeft />}
          renderOnZeroPageCount={null}
        />
      )}
    </div>
  )
}

export default Paginate
